import { GzGeneralInheritanceRulesWebComponent } from './component/GzGeneralInheritanceRulesWebComponent';

export { GzGeneralInheritanceRulesWebComponent };
